import React, { useEffect, useState } from "react";
import { intialLoading, setIndex } from "../../store/screentransistion/actions";
import { saveUserDetails } from "../../store/trackinguser/actions";
import Layout from "../common/layoutred";
import Buttonn from "../../assets/images/backgrounds/submit_button.png";
import { fetchShuffle } from "../../store/shuffledata/operations";
import { Alert } from "@material-ui/lab";
import { isAndroid } from "react-device-detect";
import "./style.scss";
import fullScreen from "../../utils/fullScreen";
import { connect } from "react-redux";
import {
  toggleMusic,
  toggleVoiceOver,
} from "../../store/screentransistion/actions";
import music from "../../assets/audio/BGMusic.mp3";
import PlayMusic from "../../utils/playMusic";
import { strings } from "../localize/strings";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {eng,hin} from '../privacypolicy';
window.gtag("event", "REGISTRATION", {
  event_category: "REGISTRATION",
  event_label: "REGISTRATION",
});

const Registration = ({
  fetchShuffle,
  shuffleData,
  progress,
  languages,
  zones,
  saveUserDetails,
  audio,
  intialLoading,
  setIndex,
  gameSessionId,
  language,
  toggleMusic,
  toggleVoiceOver,
  initialLanguage,
}) => {
  console.log(initialLanguage)
  strings.setLanguage(initialLanguage);
  const [india] = zones;
  const [english] = languages;

  const [data, setData] = useState({
    zone: india._id,
    lang: initialLanguage,
    number: "",
    name: "",
    // panCardNumber: "",
    promoCode: "",
  });

  const activate = fullScreen();

  const [error, setError] = useState(false);
  const [msg, setMsg] = useState("Please enter valid details");
  const [isChecked, setIsChecked] = useState(false)
  // const panCardRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
  const nameRegex = /^[a-zA-Z ]{2,30}$/;
  //terms and conditions
  const handleCheckbox=(event)=>{
    setIsChecked(!isChecked)
    if(event.target.checked){
      setError(false)
      setMsg("")
    }
 }
 const toggleCheckbox=()=>{
   if(!isChecked){
     setError(false)
     setMsg("")
   }
   setIsChecked(!isChecked)
 }
 const [open, setOpen] = React.useState(false);
 const [scroll, setScroll] = React.useState('paper');

 const handleClickOpen = (scrollType) => () => {
  setOpen(true);
  setScroll(scrollType);
};

const handleClose = () => {
  setOpen(false);
};

const descriptionElementRef = React.useRef(null);
React.useEffect(() => {
  if (open) {
    const { current: descriptionElement } = descriptionElementRef;
    if (descriptionElement !== null) {
      descriptionElement.focus();
    }
  }
}, [open]);

const[policy,setpolicy]=useState("")
useEffect(()=>{
  if(initialLanguage==="en"){
    setpolicy(eng)
  }
  if(initialLanguage==="hi"){
    setpolicy(hin)
  }
},[])

const[text1, setText1]=useState("")
useEffect(()=>{
  if(initialLanguage==="en"){
    setText1("By checking this box, I agree that I have read and understood ")
  }
  if(initialLanguage==="hi"){
    setText1("इस बॉक्स को चेक करके मैं सहमत हूं कि मैंने पढ़ लिया है और समझ लिया है")
  }
},[])
const[text2, setText2]=useState("")
useEffect(()=>{
  if(initialLanguage==="en"){
    setText2("privacy policy")
  }
  if(initialLanguage==="hi"){
    setText2("गोपनीयता नीति")
  }
},[])
const[close, setClose]=useState("")
useEffect(()=>{
  if(initialLanguage==="en"){
    setClose("Close")
  }
  if(initialLanguage==="hi"){
    setClose("बंद करना")
  }
},[])
  // Function to handle changes in fields.
  const handleChange = (event) => {
    const { name, value } = event.target;
    const rExp = /^[0-9\b]+$/;

    switch (name) {
      case "name":
        if (nameRegex.test(value)) {
          setData({ ...data, [name]: value.toUpperCase() });
          setError(false);
        } else {
          setData({ ...data, [name]: value.toUpperCase() });
          setError(true);
          setMsg(strings.registration.errorMessages.validName);
          return;
        }
        break;
      case "number":
        if (rExp.test(event.target.value)) {
          if (event.target.value.length <= 10) {
            setData({ ...data, [name]: value });
            setError(false);
          } else {
            setError(true);
            setMsg(strings.registration.errorMessages.allowedNumbers);
            return;
          }
        } else {
          setData({ ...data, [name]: "" });
          setError(true);
          setMsg(strings.registration.errorMessages.enterNumber);
          return;
        }
        break;
        // case "panCardNumber":
        //   if (panCardRegex.test(value.toUpperCase())) {
        //     setData({ ...data, [name]: value.toUpperCase() });
        //     setError(false);
        //   } else {
        //     setData({ ...data, [name]: value.toUpperCase() });
        //     setError(true);
        //     setMsg(strings.registration.errorMessages.validPan);
        //     return;
        //   }
        break;
      default:
        setData({ ...data, [name]: value.toUpperCase() });
        break;
    }
  };

  // Function to register.
  const register = (event) => {
    event.preventDefault();
    if(!isChecked){
      setError(true);
      setMsg('Please check the privacy policy');
      return;
    }
    if (data.number.length !== 10) {
      setError(true);
      setMsg(strings.registration.errorMessages.requiredPhone);
      return;
    }
    if (!data.name) {
      setError(true);
      setMsg(strings.registration.errorMessages.requiredName);
      return;
    } else if (!nameRegex.test(data.name)) {
      setError(true);
      setMsg(strings.registration.errorMessages.validName);
      return;
    }

    // if (!data.panCardNumber) {
    //   setError(true);
    //   setMsg(strings.registration.errorMessages.requiredPan);
    //   return;
    // } else if (!panCardRegex.test(data.panCardNumber.toUpperCase())) {
    //   setError(true);
    //   setMsg(strings.registration.errorMessages.validPan);
    //   return;
    // }

    if (data.number.length === 10 && data.lang && data.zone) {
      fetchShuffle(
        [data.lang, data.number],
        () => {
          // This is done so that audio controls are initiated as part of a user action
          toggleVoiceOver(true);
          toggleMusic(true);
          const audioRef = PlayMusic(music);
          audioRef.pause();

          intialLoading();
          setIndex(0);
          saveUserDetails(data);
          if (isAndroid) {
            activate();
          }
        },
        (err) => {
          setError(true);
          setMsg("NetWork Failed Please Check Network Connection");
        }
      );
    } else {
      setError(true);
      setMsg("All fields are required");
    }
  };

  return (
    <>
          <Layout>
        <div className="registration__container">
          <form onSubmit={register}>
           
          <div className="form__control">
              <input
                type="text"
                placeholder={strings.registration.placeholders.name}
                name="name"
                value={data.name}
                onChange={handleChange}
              />
            </div>
            <div className="form__control">
              <input
                type="number"
                placeholder={strings.registration.placeholders.number}
                name="number"
                value={data.number}
                onChange={handleChange}
              />
            </div>

            <div className="form__control">
              {/* <input
                type="text"
                placeholder={strings.registration.placeholders.panCard}
                name="panCardNumber"
                value={data.panCardNumber}
                onChange={handleChange}
              /> */}
            </div>
            <div className="form__control">
              <input
                type="text"
                placeholder={strings.registration.placeholders.promoCode}
                name="promoCode"
                value={data.promoCode}
                onChange={handleChange}
                className="promo_code_input"
              />
            </div>

          <div className="terms__condition">
             <div> <input  type="checkbox" checked={isChecked} onChange={handleCheckbox} style={{ verticalAlign: 'middle', transform:"scale(1.7)"}}/> 
              <Button style={{ marginTop: '1px'}}>
                <div className="termstext" >
                  <h2 style={{ color: 'white'}}><span onClick={toggleCheckbox}>{text1}</span><span onClick={handleClickOpen('paper')} style={{ color: 'black', textDecoration:"underline" }}>{text2}</span></h2>
                </div>
              </Button>
             <Dialog
              open={open}
              onClose={handleClose}
              scroll={scroll}
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
              >
                <DialogTitle id="scroll-dialog-title">
               {text2}
                </DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  <DialogContentText
                    id="scroll-dialog-description"
                    ref={descriptionElementRef}
                    tabIndex={-1}
                  > 
               {policy}
                    {/* {[...new Array(1)]
                      .map(
                        () => ``
                      )
                      .join('\n')} */}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>
                    <h2>{close}</h2>
                  </Button>
                  {/* <Button onClick={handleClose}>Subscribe</Button> */}
                </DialogActions>
            </Dialog>
             </div>
            </div>

            <div
              type="submit"
              className="form__control start_button"
              onClick={register}
            >
              <img src={Buttonn} alt="start_image" />
              <div type="submit" className="button__text">
                {strings.registration.button.start}
              </div>
            </div>
            <div className="form__control error__msg">
              {error ? (
                <Alert severity="error">
                  <h3>{msg}</h3>
                </Alert>
              ) : null}
            </div>
          </form>
        </div>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    shuffleData: state.shuffleData,
    progress: state.progress,
    languages: state.intialize.languages,
    zones: state.intialize.zones,
    audio: state.shuffleData,
    language: state.trackingUser.userDeatils,
    initialLanguage: state.trackingUser.initialLanguage,
  };
};

const mapDispathToProps = (dispatch) => {
  return {
    fetchShuffle: (language, success, failure) =>
      dispatch(fetchShuffle(language, success, failure)),
    saveUserDetails: (details) => dispatch(saveUserDetails(details)),
    intialLoading: () => dispatch(intialLoading()),
    setIndex: (index) => dispatch(setIndex(index)),
    toggleMusic: (toggle) => dispatch(toggleMusic(toggle)),
    toggleVoiceOver: (toggle) => dispatch(toggleVoiceOver(toggle)),
  };
};

export default connect(mapStateToProps, mapDispathToProps)(Registration);
